import {Injectable, Signal} from '@angular/core';
import {JanusService} from './janus.service';

/** The signed-in user's profile. Read from janus (see JanusService), for every IdP alike. */
@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  readonly staff: Signal<boolean>;
  readonly name: Signal<string | undefined>;
  readonly email: Signal<string | undefined>;

  constructor(janus: JanusService) {
    this.staff = janus.staff;
    this.name = janus.name;
    this.email = janus.email;
  }
}
